import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../Context/auth';
import MenuLateral from '../Components/MenuPrincipal/MenuLateral';
import MarcaForm from '../Components/MarcaForm/MarcaForm';
import './Marcas.css';
import Swal from 'sweetalert2';

function EditarMarca() {
    const { currentUser, appUserData } = useAuth();
    const navigate = useNavigate();
    const { id } = useParams();

    // Verifica permissão de edição
    useEffect(() => {
        if (appUserData && !appUserData['editar_marcas']) {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não tem permissão para editar marcas.',
                confirmButtonColor: '#2185c6'
            }).then(() => {
                navigate('/app/home');
            });
        }
    }, [appUserData, navigate]);

    const [marcaData, setMarcaData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [mensagem, setMensagem] = useState('');

    useEffect(() => {
        const fetchMarca = async () => {
            if (!id || !currentUser) return;

            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/marcas/${id}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) {
                    throw new Error("Marca não encontrada.");
                }

                const data = await response.json();
                setMarcaData(data); // Passa o objeto completo
            } catch (error) {
                setMensagem(error.message);
                setTimeout(() => navigate('/app/marcas'), 3000);
            } finally {
                setLoading(false);
            }
        };

        fetchMarca();
    }, [id, currentUser, navigate]);

    const handleAtualizar = async (dados) => {
        setMensagem('');
        setLoading(true);

        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/marcas/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ descricao: dados.descricao.trim() })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Falha ao atualizar a marca.');
            }

            navigate('/app/marcas');
        } catch (error) {
            console.error("Erro ao atualizar marca: ", error);
            setMensagem(error.message);
            setLoading(false);
        }
    };

    if (loading && !marcaData) {
        return (
            <div className="marcas-page-container">
                <MenuLateral />
                <div className="text-center p-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Carregando...</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="marcas-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="marcas-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/marcas')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="marcas-title m-0">
                            Editar <span className="highlight">Marca</span>
                        </h1>
                    </div>
                </div>

                <main className="marcas-content">
                    {mensagem && (
                        <div className="alert alert-danger d-flex align-items-center mb-4" role="alert">
                            <i className="fas fa-exclamation-circle me-2"></i>
                            <div>{mensagem}</div>
                        </div>
                    )}

                    {marcaData ? (
                        <MarcaForm
                            initialData={marcaData}
                            onSubmit={handleAtualizar}
                            loading={loading}
                            isEditing={true}
                        />
                    ) : (
                        !loading && <div className="alert alert-warning">Marca não encontrada.</div>
                    )}
                </main>
            </div>
        </div>
    );
}

export default EditarMarca;